import { get as i } from "theme-ui";
import { keyframes as t } from "@emotion/react";
const s = t({
  "0%": { opacity: 0 },
  "30%": { opacity: 1 },
  "100%": { opacity: 1 }
}), d = t({
  "0%": { opacity: 1 },
  "30%": { opacity: 0 },
  "100%": { opacity: 0 }
}), m = t({
  "0%": { opacity: 1 },
  "30%": { opacity: 1 },
  "100%": { opacity: 0 }
}), c = t({
  from: { transform: "translateY(100%)" },
  to: { transform: "translateY(0)" }
}), f = t({
  from: { transform: "translateY(0)" },
  to: { transform: "translateY(100%)" }
}), g = t({
  from: { transform: "translateX(100%)" },
  to: { transform: "translateX(0)" }
}), p = t({
  from: { transform: "translateX(0)" },
  to: { transform: "translateX(100%)" }
}), e = (a, l) => ({
  "@media (prefers-reduced-motion: no-preference)": {
    '&[data-state="open"]': (o) => ({
      animation: `${a} ${i(o, "transitions.default")}`
    }),
    '&[data-state="closed"]': (o) => ({
      animation: `${l} ${i(o, "transitions.default")}`
    })
  }
}), n = e(s, d), v = e(s, m), r = e(c, f), b = e(g, p), h = {
  base: {
    display: "flex",
    flexDirection: "column-reverse",
    justifyContent: "flex-end",
    bg: "white",
    boxShadow: "lg",
    borderRadius: "xl",
    "&:focus": {
      outline: "none"
    }
  },
  bottomSheet: {
    variant: "dialogContent.base",
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100vw",
    height: "90%",
    pt: 2,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    ...r
  },
  modal: {
    variant: "dialogContent.base",
    width: ["90%", "100%"],
    maxWidth: 136,
    my: 4,
    pt: [4, 8],
    ...n
  },
  modalBottomSheet: {
    variant: "dialogContent.base",
    width: ["90%", "100%"],
    maxWidth: 136,
    maxHeight: "90vh",
    pt: 2,
    ...r
  },
  fullScreen: {
    variant: "dialogContent.base",
    position: "fixed",
    inset: 0,
    borderRadius: 0,
    ...n
  },
  fullScreenRightSide: {
    variant: "dialogContent.base",
    position: "fixed",
    inset: 0,
    left: "auto",
    width: (a) => a.spacing(113.5),
    borderRadius: 0,
    ...b
  }
}, y = {
  base: {
    bg: "screenOverlay",
    position: "fixed",
    inset: 0,
    display: "grid",
    zIndex: "dialogOverlay",
    ...v
  },
  bottomSheet: {
    variant: "dialogOverlay.base",
    placeItems: "end center",
    overflowY: "visible"
  },
  modal: {
    variant: "dialogOverlay.base",
    placeItems: "center",
    overflowY: "auto"
  },
  modalBottomSheet: {
    variant: "dialogOverlay.base",
    placeItems: "center",
    overflowY: "visible"
  },
  fullScreen: {
    variant: "dialogOverlay.base"
  },
  fullScreenRightSide: {
    variant: "dialogOverlay.base"
  }
}, u = {
  base: {
    position: "relative",
    justifyContent: "center",
    width: "100%",
    py: 1,
    px: [4, 8]
  },
  bottomSheet: {
    variant: "dialogHeader.base"
  },
  modal: {
    variant: "dialogHeader.base"
  },
  modalBottomSheet: {
    variant: "dialogHeader.base"
  },
  fullScreen: {
    variant: "dialogHeader.base"
  },
  fullScreenRightSide: {
    variant: "dialogHeader.base",
    mt: 7
  }
}, x = {
  dialogHeader: u,
  dialogContent: h,
  dialogOverlay: y
};
export {
  x as dialogsTheme
};
